/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { CheckoutLinkProduct$inboundSchema, CheckoutLinkProduct$outboundSchema, } from "./checkoutlinkproduct.js";
import { DiscountFixedOnceForeverDurationBase$inboundSchema, DiscountFixedOnceForeverDurationBase$outboundSchema, } from "./discountfixedonceforeverdurationbase.js";
import { DiscountFixedRepeatDurationBase$inboundSchema, DiscountFixedRepeatDurationBase$outboundSchema, } from "./discountfixedrepeatdurationbase.js";
import { DiscountPercentageOnceForeverDurationBase$inboundSchema, DiscountPercentageOnceForeverDurationBase$outboundSchema, } from "./discountpercentageonceforeverdurationbase.js";
import { DiscountPercentageRepeatDurationBase$inboundSchema, DiscountPercentageRepeatDurationBase$outboundSchema, } from "./discountpercentagerepeatdurationbase.js";
import { LegacyRecurringProductPrice$inboundSchema, LegacyRecurringProductPrice$outboundSchema, } from "./legacyrecurringproductprice.js";
import { PaymentProcessor$inboundSchema, PaymentProcessor$outboundSchema, } from "./paymentprocessor.js";
import { ProductPrice$inboundSchema, ProductPrice$outboundSchema, } from "./productprice.js";
/** @internal */
export const CheckoutLinkMetadata$inboundSchema = z.union([z.string(), z.number().int(), z.boolean()]);
/** @internal */
export const CheckoutLinkMetadata$outboundSchema = z.union([z.string(), z.number().int(), z.boolean()]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var CheckoutLinkMetadata$;
(function (CheckoutLinkMetadata$) {
    /** @deprecated use `CheckoutLinkMetadata$inboundSchema` instead. */
    CheckoutLinkMetadata$.inboundSchema = CheckoutLinkMetadata$inboundSchema;
    /** @deprecated use `CheckoutLinkMetadata$outboundSchema` instead. */
    CheckoutLinkMetadata$.outboundSchema = CheckoutLinkMetadata$outboundSchema;
})(CheckoutLinkMetadata$ || (CheckoutLinkMetadata$ = {}));
export function checkoutLinkMetadataToJSON(checkoutLinkMetadata) {
    return JSON.stringify(CheckoutLinkMetadata$outboundSchema.parse(checkoutLinkMetadata));
}
export function checkoutLinkMetadataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => CheckoutLinkMetadata$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CheckoutLinkMetadata' from JSON`);
}
/** @internal */
export const CheckoutLinkDiscount$inboundSchema = z.union([
    DiscountPercentageOnceForeverDurationBase$inboundSchema,
    DiscountFixedOnceForeverDurationBase$inboundSchema,
    DiscountPercentageRepeatDurationBase$inboundSchema,
    DiscountFixedRepeatDurationBase$inboundSchema,
]);
/** @internal */
export const CheckoutLinkDiscount$outboundSchema = z.union([
    DiscountPercentageOnceForeverDurationBase$outboundSchema,
    DiscountFixedOnceForeverDurationBase$outboundSchema,
    DiscountPercentageRepeatDurationBase$outboundSchema,
    DiscountFixedRepeatDurationBase$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var CheckoutLinkDiscount$;
(function (CheckoutLinkDiscount$) {
    /** @deprecated use `CheckoutLinkDiscount$inboundSchema` instead. */
    CheckoutLinkDiscount$.inboundSchema = CheckoutLinkDiscount$inboundSchema;
    /** @deprecated use `CheckoutLinkDiscount$outboundSchema` instead. */
    CheckoutLinkDiscount$.outboundSchema = CheckoutLinkDiscount$outboundSchema;
})(CheckoutLinkDiscount$ || (CheckoutLinkDiscount$ = {}));
export function checkoutLinkDiscountToJSON(checkoutLinkDiscount) {
    return JSON.stringify(CheckoutLinkDiscount$outboundSchema.parse(checkoutLinkDiscount));
}
export function checkoutLinkDiscountFromJSON(jsonString) {
    return safeParse(jsonString, (x) => CheckoutLinkDiscount$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CheckoutLinkDiscount' from JSON`);
}
/** @internal */
export const CheckoutLinkProductPrice$inboundSchema = z.union([
    LegacyRecurringProductPrice$inboundSchema,
    ProductPrice$inboundSchema,
]);
/** @internal */
export const CheckoutLinkProductPrice$outboundSchema = z.union([
    LegacyRecurringProductPrice$outboundSchema,
    ProductPrice$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var CheckoutLinkProductPrice$;
(function (CheckoutLinkProductPrice$) {
    /** @deprecated use `CheckoutLinkProductPrice$inboundSchema` instead. */
    CheckoutLinkProductPrice$.inboundSchema = CheckoutLinkProductPrice$inboundSchema;
    /** @deprecated use `CheckoutLinkProductPrice$outboundSchema` instead. */
    CheckoutLinkProductPrice$.outboundSchema = CheckoutLinkProductPrice$outboundSchema;
})(CheckoutLinkProductPrice$ || (CheckoutLinkProductPrice$ = {}));
export function checkoutLinkProductPriceToJSON(checkoutLinkProductPrice) {
    return JSON.stringify(CheckoutLinkProductPrice$outboundSchema.parse(checkoutLinkProductPrice));
}
export function checkoutLinkProductPriceFromJSON(jsonString) {
    return safeParse(jsonString, (x) => CheckoutLinkProductPrice$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CheckoutLinkProductPrice' from JSON`);
}
/** @internal */
export const CheckoutLink$inboundSchema = z.object({
    created_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    modified_at: z.nullable(z.string().datetime({ offset: true }).transform(v => new Date(v))),
    id: z.string(),
    metadata: z.record(z.union([z.string(), z.number().int(), z.boolean()])),
    payment_processor: PaymentProcessor$inboundSchema,
    client_secret: z.string(),
    success_url: z.nullable(z.string()),
    label: z.nullable(z.string()),
    allow_discount_codes: z.boolean(),
    discount_id: z.nullable(z.string()),
    organization_id: z.string(),
    products: z.array(CheckoutLinkProduct$inboundSchema),
    discount: z.nullable(z.union([
        DiscountPercentageOnceForeverDurationBase$inboundSchema,
        DiscountFixedOnceForeverDurationBase$inboundSchema,
        DiscountPercentageRepeatDurationBase$inboundSchema,
        DiscountFixedRepeatDurationBase$inboundSchema,
    ])),
    product_id: z.string(),
    product_price_id: z.string(),
    product: CheckoutLinkProduct$inboundSchema,
    product_price: z.union([
        LegacyRecurringProductPrice$inboundSchema,
        ProductPrice$inboundSchema,
    ]),
    url: z.string(),
}).transform((v) => {
    return remap$(v, {
        "created_at": "createdAt",
        "modified_at": "modifiedAt",
        "payment_processor": "paymentProcessor",
        "client_secret": "clientSecret",
        "success_url": "successUrl",
        "allow_discount_codes": "allowDiscountCodes",
        "discount_id": "discountId",
        "organization_id": "organizationId",
        "product_id": "productId",
        "product_price_id": "productPriceId",
        "product_price": "productPrice",
    });
});
/** @internal */
export const CheckoutLink$outboundSchema = z.object({
    createdAt: z.date().transform(v => v.toISOString()),
    modifiedAt: z.nullable(z.date().transform(v => v.toISOString())),
    id: z.string(),
    metadata: z.record(z.union([z.string(), z.number().int(), z.boolean()])),
    paymentProcessor: PaymentProcessor$outboundSchema,
    clientSecret: z.string(),
    successUrl: z.nullable(z.string()),
    label: z.nullable(z.string()),
    allowDiscountCodes: z.boolean(),
    discountId: z.nullable(z.string()),
    organizationId: z.string(),
    products: z.array(CheckoutLinkProduct$outboundSchema),
    discount: z.nullable(z.union([
        DiscountPercentageOnceForeverDurationBase$outboundSchema,
        DiscountFixedOnceForeverDurationBase$outboundSchema,
        DiscountPercentageRepeatDurationBase$outboundSchema,
        DiscountFixedRepeatDurationBase$outboundSchema,
    ])),
    productId: z.string(),
    productPriceId: z.string(),
    product: CheckoutLinkProduct$outboundSchema,
    productPrice: z.union([
        LegacyRecurringProductPrice$outboundSchema,
        ProductPrice$outboundSchema,
    ]),
    url: z.string(),
}).transform((v) => {
    return remap$(v, {
        createdAt: "created_at",
        modifiedAt: "modified_at",
        paymentProcessor: "payment_processor",
        clientSecret: "client_secret",
        successUrl: "success_url",
        allowDiscountCodes: "allow_discount_codes",
        discountId: "discount_id",
        organizationId: "organization_id",
        productId: "product_id",
        productPriceId: "product_price_id",
        productPrice: "product_price",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var CheckoutLink$;
(function (CheckoutLink$) {
    /** @deprecated use `CheckoutLink$inboundSchema` instead. */
    CheckoutLink$.inboundSchema = CheckoutLink$inboundSchema;
    /** @deprecated use `CheckoutLink$outboundSchema` instead. */
    CheckoutLink$.outboundSchema = CheckoutLink$outboundSchema;
})(CheckoutLink$ || (CheckoutLink$ = {}));
export function checkoutLinkToJSON(checkoutLink) {
    return JSON.stringify(CheckoutLink$outboundSchema.parse(checkoutLink));
}
export function checkoutLinkFromJSON(jsonString) {
    return safeParse(jsonString, (x) => CheckoutLink$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CheckoutLink' from JSON`);
}
//# sourceMappingURL=checkoutlink.js.map